<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import type { User } from "firebase/auth";
import AppShell from "@/components/AppShell.vue";
import SignInView from "@/views/SignInView.vue";
import { auth } from "@/firebase";
import { useDataStore } from "@/stores/data";

const store = useDataStore();
const user = ref<User | null>(null);
const ready = ref(false);

/** Im Demo-Modus gibt es keine Anmeldung — es gibt auch nichts zu schuetzen. */
const demo = import.meta.env.VITE_DEMO === "true";
if (demo) {
  store.loadDemo();
  ready.value = true;
}

// Die Firestore-Abos duerfen erst nach der Anmeldung starten — vorher lehnen
// die Rules jeden Lesezugriff ab und die Konsole fuellt sich mit Fehlern.
const stop = demo ? () => {} : auth.onAuthStateChanged((u) => {
  user.value = u;
  ready.value = true;
  if (u) store.subscribe();
  else store.unsubscribe();
});

onMounted(() => { document.title = "STARTS Liquidität"; });
onUnmounted(() => { stop(); store.unsubscribe(); });
</script>

<template>
  <p v-if="!ready" class="grid min-h-dvh place-items-center text-ink-3">Einen Moment…</p>
  <AppShell v-else-if="user || demo" />
  <SignInView v-else />
</template>
